import { render, staticRenderFns } from "./AppInputTextFormats.vue?vue&type=template&id=dcf3c71e&scoped=true"
import script from "./AppInputTextFormats.vue?vue&type=script&lang=js"
export * from "./AppInputTextFormats.vue?vue&type=script&lang=js"
import style0 from "./AppInputTextFormats.vue?vue&type=style&index=0&id=dcf3c71e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf3c71e",
  null
  
)

export default component.exports